import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getUnitsAsUnits = async (): Promise<IGetUnitsAsUnits[]> => {
  return axiosDefaultApi.get(`/api/Units/GetUnitsAsUnits`);
};

type QueryFnType = typeof getUnitsAsUnits;

type UseGetUnitsAsUnitsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetUnitsAsUnits = ({ config }: UseGetUnitsAsUnitsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getUnitsAsUnits'],
    queryFn: () => getUnitsAsUnits(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};